// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.app-documents {
  grid-template-columns: repeat(3, auto);
}
.file-upload {
  line-height: 1.2;
  padding: 0 10px;
  background: white;
  border-bottom: 1px solid #d8d9ea;
  padding: 3px 20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/applicant-documents/applicant-documents.component.less"],"names":[],"mappings":"AAEA;EACI,sCAAA;AADJ;AAIA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,iBAAA;AAFJ","sourcesContent":["@import (reference) '../../../styles.less';\n\n.grid.app-documents {\n    grid-template-columns: repeat(3, auto);\n}\n\n.file-upload{\n    line-height: 1.2;\n    padding: 0 10px;\n    background: white;\n    border-bottom: 1px solid #d8d9ea;\n    padding: 3px 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
